import { Component, inject, Input, signal } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { LipEcouponOtpComponent } from '@web-nx-ng-tsc/ecoupon';
import { EcouponServiceService } from '../core/service/ecoupon-service.service';
import { IconfirmOTP } from '@web-nx-ng-tsc/campaign-shared-data-access';
import { tap } from 'rxjs';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'app-ecoupon-otp',
  imports: [LipEcouponOtpComponent, RouterModule],
  templateUrl: './ecoupon-otp.component.html',
  styleUrl: './ecoupon-otp.component.scss',
})
export class EcouponOtpComponent {
  private readonly ecouponService = inject(EcouponServiceService);
  private readonly loggingService = inject(LoggingService);
  
  errMsg = this.ecouponService.getErrorMessageSignal();
  errStatus = this.ecouponService.getErrorStatusSignal();
  refOTP = this.ecouponService.getRefOtpSignal();
  data = this.ecouponService.getDataFormSignal();

  router = inject(Router);
  nameRoute = signal<string>('');
  sta = signal<string>('');

  @Input() set status(status: string) {
    this.loggingService.log('route', status);
    this.sta.set(status);
  }
  constructor() {
    this.ecouponService.clearErrorMessageSignal();
  }
  emitOtp(event: { value: IconfirmOTP; timeout: boolean }) {
    this.loggingService.log('value', event.value);
    event.value.ref_no = this.refOTP();
    // this.routeToInfor();
    this.loggingService.log('OTPPPPP', this.data());
    this.ecouponService
      .confirmOTP(event.value)
      .pipe(
        tap((res: any) => {
          this.loggingService.log('OTPPPPP', res);
          if (res.ok === 1 && res.status === 1) {
            this.routeToInfor();
            this.ecouponService.clearErroStatusSignal();
          } else if (res.ok === 0 && res.status === 1) {
            if (res.error === 4 && event.timeout == true) {
              this.ecouponService.setErrorMessageSignal('OTP ของท่านหมดอายุแล้ว');
            }
          }
        })
      )
      .subscribe();
  }
  emitSendOTPAgain(timeout: boolean) {
    this.loggingService.log('data', this.data());

    this.ecouponService.postForm(this.data()).subscribe();
  }

  routeToInfor() {
    this.router.navigate([`/e-coupon/information`]);
  }
}
